import "./saga";
import { getDepartments } from "@neumetric/blueprint-lib/store";
import { DateTimeUtil } from "@neumetric/blueprint-lib/utility";
import { getRatingsTypes, getCurrentRisk } from "./helper";
export * from "./slice";
export * from "./helper";

const getRiskState = (state) => state.risk;

export const getRisksList = (state) => {
  const _state = getRiskState(state);
  return _state.risks;
};

export const getTotalRisksCount = (state) => {
  const _state = getRiskState(state);
  return _state.total_risks_count;
};

export const getOrgRisksCount = (state) => {
  const _state = getRiskState(state);
  return _state.org_risks_count;
};

export const getThreatsList = (state) => {
  const _state = getRiskState(state);
  return _state.threatsList;
};

export const getVulnerabilitiesList = (state) => {
  const _state = getRiskState(state);
  return _state.vulnerabilitiesList;
};

export const getAssetsList = (state) => {
  const _state = getRiskState(state);
  return _state.assetsList;
};

export const getAssetTypesList = (state) => {
  const _state = getRiskState(state);
  return _state.assetTypesList;
};

export const getReferenceList = (state) => {
  const _state = getRiskState(state);
  return _state.referencesList;
};

export const getSourcesList = (state) => {
  const _state = getRiskState(state);
  return _state.sourcesList;
};

export const getCategoryList = (state) => {
  const vulnerabilitiesList = getVulnerabilitiesList(state);
  return (vulnerabilitiesList || []).map((vulnerability) => ({
    id: vulnerability.category,
    label: vulnerability.category,
  }));
};

export const getRatingsList = (state) => {
  const _state = getRiskState(state);
  return _state.ratingsList;
};

export const getRatingListByType = (type, state) => {
  const _state = getRiskState(state);
  const ratingsTypes = getRatingsTypes(state);
  const result = _state.ratingsList?.[type] || [];
  return result.map((item) => {
    const ratingType = ratingsTypes.find((type) => type.id.toLowerCase() === item.rating.toLowerCase());
    return {
      ...item,
      rating: {
        id: ratingType ? ratingType.dotIconName : "ABANDONED",
        label: ratingType ? ratingType.label : item.rating,
        _id: ratingType ? ratingType.id : item.rating,
      },
    };
  });
};
export const getDepartmentResponders = (state) => {
  const _state = getRiskState(state);
  return _state.deptResponders;
};

export const getDeptResponderByDept = (responders, dept, state) => {
  let list = Array.isArray(responders) ? responders : getDepartmentResponders(state);
  return list.find((_) => {
    return _.department_name.toLowerCase() === dept.toLowerCase();
  });
};

export const getSeverityByScore = (iSeverities, score) => {
  const severities = iSeverities.slice().reverse();
  return severities[score] ? severities[score].id : "None";
};

export const getUploadRisksResult = (state) => {
  const _state = getRiskState(state);
  return _state.uploadRisksResult;
};
export const getDashboardStatsData = (state) => {
  const _state = getRiskState(state);
  return _state.dashboardData;
};

export const isRiskTolerate = (state) => {
  const currentRisk = getCurrentRisk(state);
  return currentRisk ? currentRisk.decision.toLowerCase() === "tolerate" : false;
};

export const isRiskAccepted = (state) => {
  const currentRisk = getCurrentRisk(state);
  return currentRisk ? currentRisk.status.toLowerCase() === "accepted" : false;
};

export const isRiskArchived = (state) => {
  const currentRisk = getCurrentRisk(state);
  return currentRisk ? currentRisk.status.toLowerCase() === "archived" : false;
};

export const getRiskInternalStatus = (state) => {
  const currentRisk = getCurrentRisk(state);
  return currentRisk.status.toLowerCase() === "reviewed"
    ? "Review"
    : currentRisk.status.toLowerCase() === "accepted"
      ? "Accepted"
      : currentRisk.status.toLowerCase() === "archived"
        ? "Archived"
        : "Draft";
};

export const isResponderSetForAllDepts = (state) => {
  const normalizeDeptId = (d) => d?.id || d?.label;
  const normalizeResponderDept = (r) => r?.department_name;
  const hasAssignedResponder = (r) => {
    return Boolean(r?.ent_usr_id || r?.responder?.id || (r?.responder_name && r.responder_name.trim()));
  };
  const deptResponders = getDepartmentResponders(state);
  const departments = getDepartments(state);
  // const allDeptIds = (departments || []).map(normalizeDeptId).filter(Boolean);
  const allDeptIds = (departments || [])
  .map(normalizeDeptId)
  .filter((deptId) => Boolean(deptId) && deptId.toLowerCase() !== "everyone");
  const responderByDept = new Map(
    (deptResponders || []).map((r) => [normalizeResponderDept(r), r]).filter(([k]) => Boolean(k))
  );
  if (allDeptIds.length === 0) return false;
  for (const deptId of allDeptIds) {
    const row = responderByDept.get(deptId);
    if (!row || !hasAssignedResponder(row)) return false;
  }
  return true;
};
export const getImportRisksCount = (state) => {
  const _state = getRiskState(state);
  return _state.import_risks_count;
};
export const getRiskReport = (state) => {
  const currentRisk = getCurrentRisk(state);
  return [...(currentRisk.attachments || [])]
    .sort(DateTimeUtil.sorterCB.bind(null, "created_at"))
    .find(({ title }) => title === "saved_risk_report");
};
